import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { createPortal } from 'react-dom';
import type { UserWabikenMeta } from '@/API';
import { formatWabikenMetaExpireDate } from '@/localShared/helpers/formatter/formatWabikenMetaExpireDate';
import { buildTitleThumbnailUrl } from '@/localShared/helpers/urlBuilder/buildTitleThumbnailUrl';
import { ButtonLinkPrimary } from '@/shared/components/features/buttons/ButtonLinkPrimary';
import { Spacer } from '@/shared/components/parts/Spacer';
import PlayIcon from './play.svg?url';

export const TitleCard: React.FC<{
  wabikenMeta: UserWabikenMeta;
}> = ({ wabikenMeta }) => {
  const [isDetailOpen, setIsDetailOpen] = React.useState<boolean>(false);

  const handleClickOpenDetail = (): void => {
    setIsDetailOpen(true);
  };

  const thumbnailUrl = buildTitleThumbnailUrl(
    wabikenMeta.content.thumbnails.standard
  );

  return (
    <>
      <div
        key={wabikenMeta.id}
        className="tw-group tw-relative tw-w-full tw-shadow-xl tw-shadow-main-10"
      >
        <div className="tw-aspect-[5/7] tw-w-full tw-bg-brand-lv3">
          <img
            src={thumbnailUrl}
            alt=""
            className="tw-absolute tw-inset-0 tw-aspect-[5/7] tw-object-cover"
          />
        </div>
        <div className="tw-visible tablet:tw-invisible">
          <button
            className="tw-absolute tw-inset-0"
            onClick={() => {
              handleClickOpenDetail();
            }}
          />
        </div>
        <div className="tw-invisible tw-absolute tw-inset-0 tablet:tw-visible">
          <div className="tw-grid tw-h-full tw-w-full tw-grid-cols-1 tw-grid-rows-[1fr,auto] tw-opacity-0 tw-transition-opacity tw-duration-300 tw-ease-out group-hover:tw-opacity-100">
            <Link href={`/play/${wabikenMeta.id}`} className="tw-relative">
              <Image
                src={PlayIcon}
                alt=""
                className="tw-absolute tw-inset-0 tw-m-auto tw-h-[4rem] tw-w-[4rem]"
              />
            </Link>
            <div>
              <button
                className="tw-block tw-w-full tw-bg-brand-lv1 tw-p-[0.5rem]"
                onClick={() => {
                  handleClickOpenDetail();
                }}
              >
                <div className="tw-w-full tw-text-center tw-text-base2Title tw-text-base-lv1">
                  詳細を見る
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isDetailOpen &&
        createPortal(
          <React.Fragment>
            <div className="tw-fixed tw-inset-0 tw-bg-main-80" />
            <div className="tw-fixed tw-inset-0 tw-grid tw-grid-cols-1 tw-place-items-center tw-justify-center">
              <div className="tw-relative tw-w-[calc(100%-2rem)] tw-max-w-[40rem] tw-bg-base-lv1 tw-px-[1rem] tw-py-[2rem]">
                <div className="tw-grid tw-grid-cols-1 tw-gap-[1rem] tablet:tw-grid-cols-[40%,1fr]">
                  <div>
                    <div className="tw-relative tw-mx-auto tw-aspect-[5/7] tw-w-full tw-max-w-[10rem]">
                      <div className="tw-absolute tw-bottom-0 tw-right-0 tw-aspect-[5/7] tw-w-[calc(100%-1rem)] tw-bg-brand-lv3" />
                      <img
                        src={thumbnailUrl}
                        alt=""
                        className="tw-absolute tw-left-0 tw-top-0 tw-aspect-[5/7] tw-w-[calc(100%-1rem)] tw-object-cover"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="tw-line-clamp-4 tw-text-h4 tw-leading-[1.4] tw-text-main-100 tw-halt">
                      {wabikenMeta.content.displayName}
                    </div>
                    <Spacer level={0.5} />
                    <div className="tw-text-base2">
                      {formatWabikenMetaExpireDate(
                        wabikenMeta.validityPeriod,
                        wabikenMeta.notValidAfter
                      )}
                    </div>
                    <Spacer level={2} />
                    <ButtonLinkPrimary
                      href={`/play/${wabikenMeta.id}`}
                      text="この動画を再生"
                      icon="play"
                    />
                    <Spacer level={1} />
                    <div className="tw-flex tw-justify-center">
                      <button
                        onClick={() => {
                          setIsDetailOpen(false);
                        }}
                        className="tw-flex tw-w-[12rem] tw-max-w-full tw-appearance-none tw-justify-center tw-gap-[0.5rem] tw-rounded-[0.2rem] tw-border-[2px] tw-border-brand-lv1 tw-py-[0.5rem] tw-text-center tw-transition-colors hover:tw-bg-brand-lv3"
                      >
                        <div className="tw-text-base2 tw-font-bold tw-text-brand-lv1">
                          キャンセル
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>,
          document.getElementById('modal') as Element
        )}
    </>
  );
};
